import type { Win } from "@/lib/types";

export const FELIX_WINS: Win[] = [
  {
    id: 1,
    date: "Apr 16",
    type: "call",
    account: "Alpha Account",
    quote: "I had no idea that was AI. I thought it was a real person calling me.",
    source: "Young Team test call",
    tags: ["voice quality", "trust"],
    starred: true,
  },
  {
    id: 2,
    date: "Apr 17",
    type: "text",
    account: "Alpha Account",
    quote: "Felix followed up on a lead I completely forgot about. Got a callback within 20 minutes.",
    source: "Young Team SMS thread",
    tags: ["follow-up", "speed-to-lead"],
    starred: true,
  },
  {
    id: 3,
    date: "Apr 18",
    type: "quote",
    account: "Internal",
    quote: "This is the first time I've seen AI that actually sounds like it belongs on our team.",
    source: "Ryan, internal review",
    tags: ["voice quality"],
    starred: false,
  },
];
